export default (value, divider = 20) => (
	Math.ceil(value / divider)
)